import React,{useEffect} from 'react';
import './App.scss';
import { connect } from 'react-redux'
import {Route, Switch, Redirect} from 'react-router-dom';
import HomePage from './pages/homepage/homepage.component'
import ShopPage from './pages/shop/shop.component'
import Checkout from './pages/checkout/checkout.component'
import Header from './components/header/header.component';
import {checkUserSession} from './redux/user/user.actions'
import {selectCurrentUser} from './redux/user/user.selectors'
import { createStructuredSelector } from 'reselect'
import SingInAndSignUpPage from './pages/sign-in-and-sign-up/sign-in-and-sign-up.component';
import { selectCollectionsForPreview} from './redux/shop/shop.selectors'
import {addCollectionAndDocuments} from './firebase/firebase.utils'
import collections from './shop.data'
import CashOnDelivery from './components/cashondelivery/cashondelivery.component'
import Directory from './components/directory/directory.component'
import Admin from './pages/admin/admin.component'
import Terms from './pages/term/term.component';
import Refund from './pages/refund/refund.component';
import Footer from './components/footer/footer.component';
const App = ({checkUserSession,currentUser})  => {
  
  useEffect(() => {
    checkUserSession();
  },[checkUserSession]); 
  // unsubscriberFromAuth = null
 // componentDidMount(){
  // useEffect(()=>{ Unmount
  //   const unsubscriberFromCollection = firestore
  //   .collection('collections')
  //   .onSnapshot(onSnapshot => console.log(snapshot))
  //   return  () => {
  //     unsubscriberFromCollection();
  //   }
  // })
  useEffect(() => {
    window.scrollTo(0, 0)
  }, [])
  //  const {setCurrentUser} = this.props
    // this.unsubscriberFromAuth = auth.onAuthStateChanged(async userAuth=>{
    //   if(userAuth){
    //     const userRef = await createUserProfileDocument(userAuth);
    //     userRef.onSnapshot(snapShot =>{
    //       setCurrentUser({
    //           id: snapShot.id,
    //           ...snapShot.data()
    //         });
    //     });
    //   }
    //   setCurrentUser(userAuth)
    //   
    // });
 // }
  // componentWillUnmount(){
  //   this.unsubscriberFromAuth();
  // }
  // useEffect(() => {
  //   addCollectionAndDocuments
  //     ('collections',
  //     collections.map(({title,items})=> ({title,items})));
  // }); 
    return (
      <div>
        <Header/>
        <Switch>
          <Route exact path='/' component={HomePage}/>
          <Route path='/shop' component={ShopPage}/>
          <Route exact path='/checkout' component={Checkout}/>
          <Route exact path='/categories' component={Directory}/>
          <Route  exact path='/signin' render={() => currentUser ? (<Redirect to='/'/>) : (<SingInAndSignUpPage/>)} />
          <Route exact path='/admin' render={()=><Admin email={currentUser}/>}/>
          <Route exact path="/payment" render={()=> <CashOnDelivery/>}/>
          <Route exact path="/termsandconditionsandprivacypolicy" component={Terms}/>
          <Route exact path="/returnpolicy" component={Refund}/>
        </Switch>
        <Footer/>
      </div>
    );
  }

const mapStateToProps = createStructuredSelector ({
  currentUser : selectCurrentUser,
  collectionsArray: selectCollectionsForPreview
})
const mapDispatchToProps = dispatch => ({
  checkUserSession: () => dispatch(checkUserSession())
})
export default connect(mapStateToProps,mapDispatchToProps)(App);
